import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Th = React.forwardRef((props, ref) => {
    const { children, className, asElement: Component = 'th', ...rest } = props

    const thClass = classNames(Component !== '' && 'bg-[#FFF4E5] px-4 py-3 font-lato font-medium text-[14px] leading-[150%] text-[#475467] text-start', className)

    return (
        <Component className={thClass} {...rest} ref={ref}>
            {children}
        </Component>
    )
})

Th.propTypes = {
    asElement: PropTypes.string,
}

Th.defaultProps = {
    asElement: 'th',
}

export default Th